export const listBillableUnits = `
   query listBillableUnits($filter: BillableUnitsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listBillableUnits(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              name
              description
              meterId
              meteredUnitsPerBillableUnit
              status
              meter {
                id
                meterCode
                name
              }
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getBillableUnit = `
   query getBillableUnit($id:ID!) {
       getBillableUnit(id:$id) {
         id
         name
         description
         meterId
         meteredUnitsPerBillableUnit
         status
         meter {
           id
           meterCode
           name
         }
         createdByUsername
         created
         updated
       }
}`;
